import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getRefillLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const RefillHistory = (props) => {
  const [refillHistory, setRefillHistory] = useState([]);
  const { refill_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getRefillLog(refill_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setRefillHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  // Parse extra_data to get plan_id and plan_name
  const getExtraData = () => {
    if (refillHistory.data?.extra_data) {
      try {
        return typeof refillHistory.data.extra_data === 'string'
          ? JSON.parse(refillHistory.data.extra_data)
          : refillHistory.data.extra_data;
      } catch (e) {
        return {};
      }
    }
    return {};
  };

  const extraData = getExtraData();

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Refill Log
        </Typography>
      </Box>

      {response && refillHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ICCID</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Plan ID</TableCell>
                    <TableCell align="left">Plan Name</TableCell>
                    <TableCell align="left">Transaction ID</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {refillHistory.data.msisdn}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/it/refill/batch/${refillHistory.data.batch_id}`}
                      >
                        {refillHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={refillHistory.data.status}
                        size="small"
                        color={getChipColor(refillHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {extraData.plan_id || "-"}
                    </TableCell>
                    <TableCell align="left">
                      {extraData.plan_name || "-"}
                    </TableCell>
                    <TableCell align="left">
                      {refillHistory.data.transaction_id}
                    </TableCell>
                    <TableCell align="left">
                      {refillHistory.data.last_updated &&
                        `${format(
                          new Date(refillHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={refillHistory.history?.data || []} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default RefillHistory;

